import React from "react";
import PropTypes from "prop-types";

import { CreateScale } from "./CreateScale";
import { performCreateRequest } from "../../../../../../actions/dataComponentActions";
import { useCreateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { scaleDataComponentId } from "../ScaleContainer";
import {
  connectScaleForm,
  scaleFormPropTypes,
  useScaleFormFeedback,
} from "../scaleFormWiring";

const CreateScaleContainer = ({ performCreateRequest, ...props }) => {
  useScaleFormFeedback(props.dataComponent, useCreateProcessRequests, {
    successMessage: "Scale created successfully.",
    ...props,
  });

  const handleCreateScale = values => {
    performCreateRequest(scaleDataComponentId, values);
  };

  return (
    <CreateScale
      handleCreateScale={handleCreateScale}
      closeModalDialog={props.closeModalDialog}
    />
  );
};

CreateScaleContainer.propTypes = {
  ...scaleFormPropTypes,
  performCreateRequest: PropTypes.func.isRequired,
};

export default connectScaleForm(CreateScaleContainer, { performCreateRequest });
